import React, { useMemo } from "react";
import { observer } from "mobx-react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { useAppStore } from "../../../providers/AppStoreProvider";
import { useAPI } from "../../../providers/ApiProvider";
import { toastWithAsyncFetch } from "../../../utils/helper";

import "./ProductDetailModal.scss";

export const ProductDetailModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();

  const comment = useMemo(() => {
    let result = store.comments.find((cmt) => cmt.id === store.productDetailModal.entityId);

    if (!result) {
      for (const c of store.comments) {
        result = c.childComments?.find((child) => child.id === store.productDetailModal.entityId);

        if (result) {
          break;
        }
      }
    }

    return result;
  }, [store.productDetailModal.entityId]);

  // @TODO: Duplicated in SingleComment
  const featureHandler = () => {
    const featured = comment.featured?.status === "active";

    toastWithAsyncFetch(
      {
        loading: `${featured ? "Đang bỏ" : "Đang"} đánh dấu nổi bật...`,
        success: `${featured ? "Bỏ đánh dấu" : "Đánh dấu"} nổi bật thành công`,
        error: `Xảy ra lỗi, ${featured ? "bỏ đánh dấu" : "đánh dấu"} nổi bật thất bại!`,
      },
      () =>
        api.callApi("featureComment", {
          params: { pk: comment.id },
          body: { status: featured ? "inactive" : "active" },
        }),
      (res) => {
        comment.setFeature(res.data.featured);
      },
    );
  };

  return (
    store.productDetailModal.entityId &&
    comment && (
      <Modal
        size="xl"
        show={store.productDetailModal.show}
        onHide={store.productDetailModal.toggle}
        className="product-detail-modal"
      >
        <Modal.Body className="d-flex flex-column align-items-center">
          <div
            className="d-flex flex-column flex-lg-row justify-content-between align-items-center mt-2 mb-4"
            style={{ maxWidth: 720 }}
          >
            <div className="d-flex flex-row mb-3 mb-lg-0">
              <div>
                <div className="avatar avatar-xl rounded-circle overflow-hidden me-3">
                  <img src={comment.creator.avatar_url} alt="" />
                </div>
              </div>
              <div className="flex-grow-1">
                <div className="fw-bold">{comment.creator.name}</div>
                <Link
                  to={`/lesson/${store.course.id}/${comment?.lesson.id ?? 0}`}
                  className="text-black-50 limit-line one-line w-75"
                  onClick={() => store.productDetailModal.toggle()}
                >
                  {comment.lesson.name}
                </Link>
              </div>
            </div>

            <div
              role="button"
              className="d-flex justify-content-between align-items-center fw-semibold feature-btn text-nowrap p-2 px-3 rounded-10"
              data-featured={comment.featured?.status === "active"}
              onClick={featureHandler}
            >
              <FontAwesomeIcon icon={faStar} className="me-2" />
              {comment.featured?.status === "active" ? "Đã đánh" : "Đánh"} dấu nổi bật
            </div>
          </div>
          <div className="py-lg-3 px-lg-5">
            <img src={comment?.image_url} alt="" className="w-100 rounded" />
          </div>
        </Modal.Body>
      </Modal>
    )
  );
});
